export default "__VITE_ASSET__BimImPR5__";